import React, { useState, useMemo, useRef } from 'react';
import { Form, Table, Row, Button, Input, Pagination, PaginationItem, PaginationLink, FormGroup, Col, Label } from 'reactstrap';
import { useTranslate } from 'react-translate';
import { useSortBy, useTable, usePagination } from 'react-table';
import moment from "moment";
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import LaboratoryService from "../../services/LaboratoryService";
import MultimediaService from "services/MultimediaService";
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import nativeSender from 'helpers/nativeSender';
import { actionGetLabStudies } from 'store/actions/laboratoryActions';

import { 
    actionSetLoadingStudy, 
    actionSetSearchQuery, 
    actionSaveCurrentLaborScroll,
    actionSetFromDetailsLabor,
    actionSetPageIndex,
    actionSetLoadingStudyList
} from 'store/actions/laboratoryActions';
import { actionInvitePatient } from 'store/actions/patientsActions';
import Icon from "components/Icons/Icon";
import ReactTooltip from 'react-tooltip';
import SweetAlert from 'react-bootstrap-sweetalert';
import { actionSweetAlert } from 'store/actions/commonActions';
import ScrollButton from 'components/Common/ScrollButton';
import useAuthorizationValidator from 'plugins/TS-lib-utils-public/hooks/useAuthorizationValidator';
import PdfLoadingButton from 'components/Common/Laboratory/LaboratoryPdfDownload';

const StudiesList = () => {
    const t = useTranslate('studies-list');
    const dispatch = useDispatch();
    const thl7 = useTranslate('hl7-status');
    const { handleSubmit, register } = useForm();
    const practiceId = useSelector(state => state.practicesReducer.practice._id);
    const { doctorInfo } = useSelector(state=>state.userDataReducer);
    const user = useSelector(state => state.userReducer);
    const laboratoryList = useSelector(state => state.laboratoryReducer.studies);
    const { checkAccess } = useAuthorizationValidator();
    const refreshTable = useRef(false);
    const lastPage = useSelector(state => state.laboratoryReducer.lastPage);
    const pageLimit = useSelector(state => state.laboratoryReducer.limit);
    const pageState = useSelector(state => state.laboratoryReducer.page);
    const totalEntries = useSelector(state => state.laboratoryReducer.totalEntries);
    const loadingStudyList = useSelector(state => state.laboratoryReducer.loadingStudyList);
    const [sortDate, setSortDate] = useState(-1);
    const querySearch = useSelector(state => state.laboratoryReducer.querySearch);
    const coming = useSelector(state => state.laboratoryReducer.comingFromDetails);
    const scroll = useSelector(state => state.laboratoryReducer.laborListScroll);
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [showDatePick, setShowDatePick] = useState(false);
    const history = useHistory();
    const { nativeWebView } = useSelector(state => state.commonReducer);

    const roles = useSelector(state => state.userAuthorizationReducer);
    const isSecretary = roles.key === "secretary";

    const invitePatient = (patientId, reportId) => {
        dispatch(actionInvitePatient(patientId, doctorInfo.practices[0].doctor_ext_ref, reportId));
    }

    const onSubmit = (data) => {
        const query = data.query.trim();
        dispatch(actionSetSearchQuery(query));
        gotoPage(0);
    }

    // const handleInfoClick = (index) => {
    //     const updatedState = data[index];

    //     if (updatedState.other) {
    //         delete updatedState.other;
    //         setState((pre) => {
    //             return pre + 1;
    //         });
    //     } else {
    //         updatedState.other = {
    //             description: "Hello there" //or data from api
    //         };
    //         setState((pre) => {
    //             return pre + 1;
    //         });
    //     }
    // };

    const showAlert = (patientId, studyId, patientData = {}) => {
        dispatch(
            actionSweetAlert(
                <SweetAlert
                    custom
                    customIcon="/General/icons/warning-sign-orange.svg"
                    title={t('invitation-are-you-sure')}
                    onConfirm={() => {}}
                    customButtons={
                        <div className="d-flex">
                            {/*Custom buttons for more control*/}
                            <Button
                                className="mb-3"
                                color="info"
                                size="lg"
                                testId="invitation_ok"
                                onClick={() => {
                                    invitePatient(patientId, studyId);
                                    dispatch(actionSweetAlert(<></>));
                                }}
                            >
                                {t('btn-yes')}
                            </Button>

                            <Button
                                className="mb-3"
                                color="primary"
                                size="lg"
                                testId="invitation_back"
                                onClick={() => {
                                    dispatch(actionSweetAlert(<></>));
                                }}
                            >
                                {t('btn-no')}
                            </Button>
                        </div>
                    }
                >
                    <div testId="invitation_exp">
                        {Object.keys(patientData).length && patientData.invitations && patientData.invitations.length ? (
                            <>
                                {t('invitation-exp-pending')}<br/>
                                {`${t('invitation-exp-pending-s1')}: ${moment(patientData.invitations[0].sent_at).format(`${user.dateFormat} HH:mm`)}`}<br/>
                            </>
                        ) : (<>{t('invitation-exp-first')}</>)}
                    </div>
                </SweetAlert>
            )
        );
    }

    const data = useMemo(
        () => laboratoryList && laboratoryList != "loading" ? laboratoryList.map((p, i) => {

            const reportData = {
                registerid: p.hl7_lab_results_id,
                external_id : p.orderNumber,
                eingangsdatum: moment(p.created_at, "YYYYMMDDhhmmss").format(user.dateFormat),
                patient: `${p.patient.firstName} ${p.patient.lastName} * ${moment(p.patient.birthday, "YYYYMMDD").format(user.dateFormat)}`,
                doctor: !isSecretary ? undefined : `${p.doctor.data.firstName} ${p.doctor.data.lastName}`,
                studyType: p.studyType ? t(p.studyType.toLowerCase().replace(" ", "-")) : "-",
                review: 
                    <div className='d-flex justify-content-between'>

                        <ReactTooltip
                            id={`review-readed-${i}`}
                            aria-haspopup="true"
                            effect="float"
                            type="dark"
                            place="bottom"
                            className={!p.review?.readed_at ? "d-none" : ""}
                        >
                            <div testId="editor_blocked_tooltip">{moment(p.review?.readed_at).format(`${user.dateFormat} HH:mm`)}</div>
                        </ReactTooltip>

                        <ReactTooltip
                            id={`review-sent-${i}`}
                            aria-haspopup="true"
                            effect="float"
                            type="dark"
                            place="bottom"
                            className={p.review?.readed_at || !p.review?.sent_at ? "d-none" : ""}
                        >
                            <div testId="editor_blocked_tooltip">{moment(p.review?.sent_at).format(`${user.dateFormat} HH:mm`)}</div>
                        </ReactTooltip>

                        <div data-tip data-for={p.review?.readed_at  ? `review-readed-${i}` : p.review?.sent_at ? `review-sent-${i}` : ""}>
                            {p.review?.readed_at ? t("status-readed")+" " : !p.review?.sent_at ? t("status-open") : t("status-sent")}
                            {p.review?.readed_at ? <i style={{color:"#bbb"}} class='fa fa-check'></i> : <></>}
                            <br/>
                            
                                {p.review?.readed_at 
                                ? moment(p.review?.readed_at).format(`${user.dateFormat}`) 
                                : p.review?.sent_at 
                                ? moment(p.review?.sent_at).format(`${user.dateFormat}`) 
                                : ""}
                            
                        </div>
                        {p?.review?.isBilling ? 
                            <span >
                                <Icon file={`euro-currency-symbol_green.svg`} width="20px" height="20px"/>
                            </span>
                        : <></>}
                    </div>
                ,
                additionalInfo: {
                    "Practice": p.practice,
                    "Study ID": p.reportId,
                    "Control Number": p.controlNumber,
                    "Order Number": p.orderNumber,
                },
                status: `${thl7(p.status)}`,
                berichtsdatum: moment(p.updated_at, "YYYYMMDDhhmmss").format(user.dateFormat),
                telepraxenUser:
                    <React.Fragment key={`patient-istp-${p._id}-${i}`}>
                        { p.patient.isTelepraxen === 1 ? (
                            <Button color="info" active={false} disabled testId={`labor-study-${i+1}-patient-exists`}>
                                TP
                            </Button> 
                        ) : p.patient.isTelepraxen === 2 ? (
                            <Button testId={`labor-study-${i+1}-patient-pending`} color="default" onClick={() => {
                                showAlert(p.patient.pifs_id, p._id, p.patient);
                            }}>
                                Erneut einladen <i className="icon icon-send ml-1"></i>
                            </Button> 
                        ) : (
                            <Button testId={`labor-study-${i+1}-patient-missing`} color="primary" onClick={() => {
                                showAlert(p.patient.pifs_id, p._id, p.patient);
                            }}>
                                Einladen <i className="icon icon-send ml-1"></i>
                            </Button> 
                        )
                        }
                    </React.Fragment>
                ,
                c5: p?.readed ? "true" : "",
                c6: 
                    checkAccess("practice-laboratory", "labor-editor") ? (
                        <Button
                            testId={`labor-study-${i+1}`}
                            key={`report-link-${p.reportId}-${p.patient.pifs_id}`}
                            color="info"
                            onClick={() => {
                                //Save current page scroll
                                const fullPage = document.getElementById("full-page");
                                dispatch(actionSaveCurrentLaborScroll(fullPage.scrollTop));

                                document.getElementById("full-page").scrollTop = 0;
                                dispatch(actionSetLoadingStudy(true));
                                history.push(`lab-studies-detail/${p._id}`);
                            }}
                        >
                            {t('details')}
                        </Button>
                    )
                    : <></>,
                c7: p.reportFileExists && <PdfLoadingButton 
                        reportId={p._id} 
                        doctorId={p.doctor.pifs_id} 
                        patientId={p.patient.auth_user_id}
                        practiceId={practiceId}
                        prompt={<i className="icon icon-attach ml-2"></i>}
                        buttonSize="sm"
                />,

                //TODO - REsolve toggle hide/show additional info
                //info: <Button key={`ButtonToggler${p.reportId}-${p.patient.pifs_id}`} id={`ButtonToggler${p.reportId}`} color="info" >&#9432;</Button>
            };

            return { ...reportData };
        }) : [],
        //eslint-disable-next-line
        [laboratoryList, t]
    );


    const columns = useMemo(
        () => {

            const columns = [];

            //Push normal fields in order
            columns.push(
                {
                    accessor: "registerid",
                    // defaultCanSort: false
                },
                {
                    accessor: "additionalInfo",
                    // defaultCanSort: false
                },
                {
                    Header: `${t('report-date')}`,
                    accessor: "berichtsdatum",
                    // defaultCanSort: false,
                },
                {
                    Header: `${t('id')}`,
                    accessor: "external_id",
                    // 
                },
                {
                    Header: `${t('patient')}`,
                    accessor: "patient",
                    // defaultCanSort: false,
                    // disableSortBy: true
                },
                {
                    accessor: "telepraxenUser",
                    // defaultCanSort: false,
                    // disableSortBy: true
                },
                {
                    Header: `${t('study-type')}`,
                    accessor: "studyType"
                },
            );

            //Push secretary exclusive fields
            if (isSecretary) {
                columns.push({
                    Header: `${t('doctor')}`,
                    accessor: "doctor"
                });
            }

            columns.push( 
                {
                    Header: `${t('status')}`,
                    accessor: "status",
                    // defaultCanSort: false,
                    // disableSortBy: true
                },
                {
                    Header: `Kommentar`,
                    accessor: "review",
                    // defaultCanSort: false,
                    // disableSortBy: true
                }
            );

            //Hide actions column if user has the secretary role
            if (!isSecretary) {
                columns.push({
                    Header: `${t('actions')}`,
                    accessor: "c6",
                    // defaultCanSort: false,
                    // disableSortBy: true
                });
            }

            columns.push({
                Header: `PDF`,
                accessor: "c7",
                // defaultCanSort: false,
                // disableSortBy: true
            });

            return columns;
        },
        //eslint-disable-next-line
        [t]
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex, pageSize }
    } = useTable({
        columns,
        data,
        disableSortRemove: true,
        enableSortingRemoval: true,
        defaultCanSort: true,
        initialState: {
            pageSize: pageLimit,
            pageIndex: pageState,
            hiddenColumns: ["registerId", "additionalInfo"],
        },
        manualPagination: true,
        pageCount: lastPage + (totalEntries > pageLimit),
        autoResetPage: !refreshTable.current
    },
        useSortBy,
        usePagination);

    const goToPageNumber = (page) => {
        dispatch(actionSetPageIndex(page));
        gotoPage(page);
    }

    const goNextPage = () => {
        dispatch(actionSetPageIndex(pageIndex + 1));
        nextPage();
    }

    const goPreviousPage = () => {
        dispatch(actionSetPageIndex(pageIndex - 1));
        previousPage();
    }

    useEffect(() => {
        if (practiceId) {
            refreshTable.current = true;
            document.getElementById("full-page").scroll(0,0);
            dispatch(actionGetLabStudies({
                practiceId, 
                pageIndex, 
                pageSize, 
                sortDate, 
                querySearch, 
                dateFrom,
                dateTo
            }));
        }
    }, [pageIndex, pageSize, sortDate, querySearch, practiceId]);

    //Setup scroll effect after component loading
    useEffect(() => {
        if (!loadingStudyList && laboratoryList.length && scroll && coming) {
            document.getElementById("full-page").scrollTop = scroll;
            dispatch(actionSaveCurrentLaborScroll(0));
            dispatch(actionSetFromDetailsLabor(false));
        } else {
            document.getElementById("full-page").scrollTop = 0;
        }
    }, [laboratoryList]);


    useEffect(() => {
        refreshTable.current = false;
    }, []);

    useEffect(() => {
        if (!coming && practiceId) {
            goToPageNumber(0);
            document.getElementById("full-page").scroll(0,0);
            dispatch(actionGetLabStudies({
                practiceId, 
                pageIndex, 
                pageSize, 
                sortDate: -1, 
                querySearch,
                dateFrom,
                dateTo
            }));
        }
    }, [dateFrom, dateTo]);

    useEffect(() => {
        return () => {
            dispatch(actionSetLoadingStudyList(true));
        }
    }, []);

    //Pagination info
    const firstEntry = (pageIndex * pageLimit) + 1;
    const lastEntry = (pageIndex * pageLimit) + pageLimit > totalEntries ? totalEntries : (pageIndex * pageLimit) + pageLimit;
    const pageInfo = totalEntries > 0 ? t("pagination-info", {firstEntry, lastEntry, totalEntries}) : t("no-results");

    return (
        <>

            <ScrollButton minScroll={600} condition={true} />

            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col xs={4} sm={3}>
                        <FormGroup
                        className="mt-2">
                            <Input 
                            className="form-control"
                                type="text"
                                innerRef={register}
                                name="query"
                                id="query"
                                placeholder={t('search-patient')}
                                defaultValue={querySearch}
                            />

                            {querySearch.length ? (
                                <button 
                                className="msg_send_btn" 
                                type="button" 
                                onClick={() => {
                                    document.getElementById("query").value = "";
                                        dispatch(actionSetSearchQuery(""))
                                    }}>
                                    <span className="icon-trash"></span>
                              </button>
                            ) : (<></>)}
                        </FormGroup>
                    </Col>

                    <Col xs={1}>
                        <Button
                            size="md"
                            color="info"
                            type="submit"
                            name="search-study"
                        >
                            {t("search-button")}
                        </Button>
                    </Col>

                    <Col className="ml-auto mr-3" xs={4} lg={3}>
                        <FormGroup className="mt-2">
                            <Input type="select" name="filter-date-study" onChange={(e) => {
                                setShowDatePick(isNaN(new Date(e.target.value)));
                                let date = new Date(e.target.value);
                                if (!isNaN(date)) {
                                    if (date.getFullYear() < 1900) {
                                        setDateFrom(null);
                                        setDateTo(null);
                                    } else {
                                        setDateFrom(e.target.value);
                                    }
                                    setShowDatePick(false);
                                }
                            }}>
                                <option value={"1800-01-01"} selected>
                                    {t("datepick-show-all")}
                                </option>
                                <option value={moment(Date.now() - 7 * 24 * 60 * 60 * 1000).format("YYYY-MM-DD")}>
                                    {t("datepick-last7")}
                                </option>
                                <option value={moment(Date.now() - 30 * 24 * 60 * 60 * 1000).format("YYYY-MM-DD")}>
                                    {t("datepick-last-month")}
                                </option>
                                <option>
                                    {t("datepick-personalized")}
                                </option>
                            </Input>
                         </FormGroup>
                    </Col>

                    
                </Row>

                {showDatePick && (
                    <Row>
                        <Col>
                            <Label>{t('datepick-from')}</Label>
                            <FormGroup>
                                <Input
                                    name="from"
                                    id="from"
                                    type="date"
                                    innerRef={register}
                                    onChange={(e) => {
                                        setDateFrom(e.target.value);
                                    }}
                                />
                            </FormGroup>
                        </Col>

                        <Col>
                            <Label>{t('datepick-to')}</Label>
                            <FormGroup>
                                <Input
                                    name="to"
                                    id="to"
                                    type="date"
                                    innerRef={register}
                                    onChange={(e) => {
                                        setDateTo(e.target.value);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                )}
            </Form>
            

            {loadingStudyList || !practiceId ? <LoadingLocal/> : (
                <div className="table-responsive">
                    <Table {...getTableProps()}>
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th
                                            className={` class-nowrap session-table-header ${column.id === "c4" ? "sortable-header" : ""} ${column.id === "registerid" ? "d-none" : ""}`}
                                            {...column.getHeaderProps(column.getSortByToggleProps())}
                                            onClick={column.id === "berichtsdatum" ? e => {
                                                setSortDate(!sortDate ? 1 : sortDate === 1 ? -1 : 0);
                                            } : undefined}
                                        >
                                            {column.render('Header')}
                                            {column.id === "berichtsdatum" && (
                                                <span>
                                                    <b className={`${sortDate != 0 ? sortDate === -1 ? "caret-desc" : "caret-asc" : "caret-default"}`}></b>
                                                </span>
                                            )}
                                        </th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {laboratoryList === "loading" ? (<tr><td><LoadingLocal /></td></tr>)
                                : (
                                    page.map((row, index) => {
                                        prepareRow(row)
                                        return (
                                            <React.Fragment key={`tbody-${index}`}>
                                                <tr {...row.getRowProps((state, rowInfo) => {
                                                    if (rowInfo && rowInfo.row) {
                                                        return {
                                                            style: {
                                                                fontWeight: !rowInfo.row.original.c5.length ? 'bold' : 'normal',
                                                            }
                                                        }
                                                    } else return {}
                                                })}>
                                                    {row.cells.map((cell, ci) => {
                                                        return (
                                                            <td
                                                                {...cell.getCellProps({ key: `tr_${index}_${ci}` })}
                                                                className={`${cell.column.id === "c1" ? "d-flex" : ""} ${cell.column.id === "registerid" ? "d-none" : ""}`}
                                                            >
                                                                {cell.column.id === "c1" && <div className={`dot-${cell.value === "Unavailable" ? "un" : ''}available`}></div>}
                                                                {cell.render('Cell')}
                                                            </td>
                                                        )
                                                    })}
                                                </tr>

                                                <tr {...row.getRowProps({ key: `row_${index}_2` })}>
                                                    {/* <pre> */}
                                                    {
                                                        row.cells.map((cell, index) => {
                                                            {/* { console.log(cell.column.id) } */ }

                                                            {/* {
                                                                    if (cell.column.id == "registerid") {
                                                                        return (
                                                                            <pre>{cell.column.id}</pre>
                                                                        )
                                                                    } else {
                                                                        return (null)
                                                                    }
                                                                } */}
                                                            if (cell.column.id === "registerid") {

                                                                return (

                                                                    <td {...cell.getCellProps({ key: `cell_${index}_2` })} colSpan={9} style={{ borderTop: "none" }}>
                                                                        {/* 
                                                                        
                                                                        TODO - Resolve toggle hide/show aditional info
                                                                        
                                                                        <UncontrolledCollapse
                                                                            toggler={`#ButtonToggler${cell.value}`}>
                                                                            <>
                                                                                {Object.keys(cell.row.allCells[1].value).map((v,i) => {
                                                                                    return (
                                                                                        <p key={`p-${v}-${i}`}>{`${v}: ${cell.row.allCells[1].value[v]}`}</p>
                                                                                    )
                                                                                })}
                                                                            </>
                                                                        </UncontrolledCollapse>
                                                                            */}
                                                                    </td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                    {/* </pre> */}
                                                </tr>
                                            </React.Fragment>
                                        )
                                    })
                                )}
                        </tbody>
                    </Table>
                </div>
            )}
            

            <Row className="text-center justify-content-center mt-3">
                <nav aria-label="Page navigation example">
                    <Pagination
                        className="pagination justify-content-end"
                        listclassname="justify-content-end"
                    >
                        <PaginationItem disabled={!canPreviousPage}>
                            <PaginationLink
                                href="#previous-page"
                                onClick={e => {
                                    e.preventDefault()
                                    goPreviousPage()
                                }}
                                tabIndex="-1"
                                className="bg-info text-white"
                            >
                                <i className='fa fa-angle-double-left'></i>
                            </PaginationLink>
                        </PaginationItem>
                        <PaginationItem disabled={pageIndex < 2}>
                            <PaginationLink href="#minus-two" onClick={e => {
                                e.preventDefault();
                                goToPageNumber(pageIndex - 2);
                            }}>
                                {canPreviousPage && pageIndex > 1 ? pageIndex - 1 : " "}
                            </PaginationLink>
                        </PaginationItem>
                        <PaginationItem disabled={pageIndex === 0}>
                            <PaginationLink href="#minus-one"
                                onClick={e => {
                                    e.preventDefault();
                                    goPreviousPage()
                                }}>
                                {!canPreviousPage ? " " : pageIndex}
                            </PaginationLink>
                        </PaginationItem>
                        <PaginationItem active>
                            <PaginationLink href="#actual-page" onClick={e => { e.preventDefault() }} className="bg-info">
                                {pageIndex + 1}
                            </PaginationLink>
                        </PaginationItem>
                        <PaginationItem disabled={!canNextPage}>
                            <PaginationLink href="#plus-one" onClick={e => {
                                e.preventDefault();
                                goNextPage();
                            }}>
                                {canNextPage ? pageIndex + 2 : " "}
                            </PaginationLink>
                        </PaginationItem>
                        <PaginationItem disabled={!(pageCount - pageIndex > 2)}>
                            <PaginationLink href="#plus-two" onClick={e => {
                                e.preventDefault();
                                goToPageNumber(pageIndex + 2);
                            }}>
                                {(pageCount - pageIndex > 2) ? pageIndex + 3 : " "}
                            </PaginationLink>
                        </PaginationItem>
                        <PaginationItem disabled={!canNextPage}>
                            <PaginationLink href="#next-page" onClick={e => {
                                e.preventDefault();
                                goNextPage();
                            }}
                                className="bg-info text-white"
                            >
                                <i className='fa fa-angle-double-right'></i>
                            </PaginationLink>
                        </PaginationItem>
                    </Pagination>

                    <Label>{pageInfo}</Label>
                </nav>
            </Row>
        </>
    );
};

export default StudiesList;
